import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Tooltip,
  Typography,
  message,
  Select,
} from "antd";

import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AUTH_TOKEN,
  DOMAIN_ID,
  ORG_ID,
  REACT_APP_API,
  REACT_APP_API_PAM_URL,
  REACT_APP_API_TENANTS_URL,
} from "../../../../constants";
import { logOutUser } from "../../../../common";
import { CodeBlock } from "../../../../pages/enduser/ssh-proxy/sshProxyUi";
import { OnboardShell, PartHead, StepRow, card } from "./onboardUi";
import { DownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import JSZip from "jszip";

import copyText from "../../../../utils/copyText";
export const OnboardWindowV2 = ({ embedded = false, onDone }) => {
  const [notification, setNotification] = message.useMessage();
  const navigate = useNavigate();
  const { Text } = Typography;
  const [form] = Form.useForm();

  const [code, setCode] = useState("");
  const [publicIp, setPublicIp] = useState("");
  const [privateIp, setPrivateIp] = useState("");
  const [description, setDescription] = useState("");

  const [fqdn, setFqdn] = useState("");
  const [uuid, setUuid] = useState("");
  const [aDData, setADData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState();
  const [aDInfo, setADInfo] = useState(null);
  const [activeDirectory, setActiveDirectory] = useState([]);
  const [entraDirectory, setEntraDirectory] = useState([]);
  const [adMfaMode, setAdMfaMode] = useState(0);
  const [domainGroups, setDomainGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [adId, setAdId] = useState(null);
  const [userType, setUserType] = useState(null);
  const [tenantLogo, setTenantLogo] = useState("");
  const userTypeOptions = [
    { value: "local", label: "Local Users Only" },
    { value: "ldap", label: "LDAP/Active Directory Users Only" },
    { value: "entra", label: "EntraID" },
    { value: "both", label: "BOTH ( Local + LDAP )" },
  ];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const MFAType = queryParams.get("MFA");
  const ADID = queryParams.get("adId");

  useEffect(() => {
    if (MFAType === "ldap") {
      setUserType("ldap");
      form.setFieldsValue({
        userType: "ldap",
      });
    }
  }, [MFAType, form]);

  useEffect(() => {
    generateDynamicUuid();
    fetchADMachine();
  }, []);

  useEffect(() => {
    if (adId !== null) {
      fetchGroupsByDomain();
    }
  }, [adId]);

  useEffect(() => {
    fetchAgentKey();
    setFormData([{ name: ["token"], value: code }]);
  }, [code]);


  useEffect(()=> {
    if(userType === "ldap" || userType === "both" || userType === "entra") {
      setADInfo(null)
      setAdId(null);
      form.resetFields(["AdMachine"]);
      userType === "entra" ? setADData(entraDirectory) : setADData(activeDirectory)
    }
  }, [userType, activeDirectory, entraDirectory, form]);

  // Function to fetch tenant details and get the image URL
  const fetchTenantDetails = async () => {
    try {
      const tenantPayload = {
        email: localStorage.getItem("UserName"),
        tenantId: DOMAIN_ID(),
        orgId: ORG_ID(),
      };

      const response = await axios.post(
        `${REACT_APP_API_TENANTS_URL}/getTenantDetail`,
        tenantPayload,
        {
          headers: {
            withCredentials: true,
            "X-Authorization": AUTH_TOKEN(),
          },
        }
      );

      if (response && response.data && response.data.data) {
        const imageUrl = response.data.data.imageUrl || "";
        setTenantLogo(imageUrl);
        return response.data.data;
      }
      return "";
    } catch (error) {
      console.error("Error fetching tenant details:", error?.response?.status, error?.message);
      notification.open({
        type: "error",
        content: "Unable to fetch tenant details",
      });
      return "";
    }
  };

  // Function to construct the env file content line by line
  const generateEnvContent = (data) => {
    // Use the passed imageUrl if provided, otherwise fall back to the state value
    const logoUrl = data?.imageUrl || "" || tenantLogo;
      // `AWS_ACCESS_KEY_ID=${data?.sessionrecordingkey}`,
      // `AWS_SECRET_ACCESS_KEY=${data?.seesionrecordingsecret}`,
      // `AWS_REGION=${data?.sessionrecordingregion}`,
      // `BUCKET_NAME=${data?.sessionrecordingbucketname}`,
    const envLines = userType === "entra" ? [] : [
      `KEY=KL01`,
      `PUBLIC_IP=${publicIp}`,
      `PRIVATE_IP=${privateIp}`,
      `FQDN=${fqdn}`,
      `DESCRIPTION=${description || ""}`,
      `MACHINE_KEY=MACKL01`,
      `AGENT_TOKEN=${code}`,
      `TENANT_ID=${localStorage.getItem("DomainId")}`,
      `ORG_ID=${localStorage.getItem("OrgId")}`,
      `USER_ID=${localStorage.getItem("userId")}`,
      `RECORDING_DIR=/anchor_dvr/`,
      `TEXT_RECORDING_DIR=/text_recordings/`,
      `FILE_NAME=test.guac`,
      `BUCKET_NAME_GCS=gto-did-app-dev`,
      `STORAGE_AWS_FLAG=true`,
      `INSTALL_SERVICES=false #`,
      `ADMFA=${adMfaMode}`,
      `UUID=${uuid}`,
      `IMAGE_URL=${logoUrl}`,
    ];

    if (userType === "local") {
      envLines.push("USER_TYPE=Local");
    } else if (userType === "ldap") {
      envLines.push("USER_TYPE=LDAP");
      if (aDInfo) {
        envLines.push(`LDAP_HOST=${aDInfo.adHost}`);
        envLines.push(`LDAP_PORT=${aDInfo.port}`);
        envLines.push(`SEARCH_DN=${aDInfo.dc}`);
        envLines.push(`GROUP_DN_PATTERN=${aDInfo.dc}`);
        envLines.push(`USER_DN_PATTERN=CN=%u,${aDInfo.dc}`);
        envLines.push(`PASSWORD=${aDInfo.password}`);
        envLines.push(`PreferredDNS=${aDInfo.adHost}`);
        envLines.push(`DomainAdmin=${aDInfo.adAdminUsername}`);
        envLines.push(`DomainName=${aDInfo.dc1}.${aDInfo.dc2}`);
        envLines.push(`GROUPS=${selectedGroups.join(",")}`);
      }
    } else if (userType === "both") {
      // For "both", do not include a USER_TYPE field.
      if (aDInfo) {
        envLines.push(`LDAP_HOST=${aDInfo.adHost}`);
        envLines.push(`LDAP_PORT=${aDInfo.port}`);
        envLines.push(`SEARCH_DN=${aDInfo.dc}`);
        envLines.push(`GROUP_DN_PATTERN=${aDInfo.dc}`);
        envLines.push(`USER_DN_PATTERN=CN=%u,${aDInfo.dc}`);
        envLines.push(`PASSWORD=${aDInfo.password}`);
        envLines.push(`PreferredDNS=${aDInfo.adHost}`);
        envLines.push(`DomainAdmin=${aDInfo.adAdminUsername}`);
        envLines.push(`DomainName=${aDInfo.dc1}.${aDInfo.dc2}`);
        envLines.push(`GROUPS=${selectedGroups.join(",")}`);
      }
    }
    else if (userType === "entra") {
       envLines.push(`ORG_ID=${ORG_ID()}`);
       envLines.push(`TENANT_ID=${DOMAIN_ID()}`);
      };

    return envLines.join("\n");
  };

  const createZipAndDownload = async () => {
    try {
      // First fetch tenant details to get the logo URL
      const imageUrl = await fetchTenantDetails();

      // Generate env content with the latest image URL value
      const textContent = generateEnvContent(imageUrl);

      const zip = new JSZip();
      const url = userType === "entra" ?  
        "https://raw.githubusercontent.com/authnull0/windows-endpoint/main/entra-script.ps1"
      :
        "https://raw.githubusercontent.com/authnull0/windows-endpoint/refs/heads/main/windows-agent-install.ps1";

      // Add the .env file content into the ZIP
      zip.file("app.env", textContent);

      // Fetch the installation script from the URL and add to the ZIP
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");

      const fileBlob = await response.blob();

      zip.file("windows-agent-install.ps1", fileBlob);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(zipBlob);
      link.download = "windows-agent-install.zip";
      link.click();

      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error preparing download:", error?.response?.status, error?.message);
      notification.open({
        type: "error",
        content: "Error preparing download file",
      });
    }
  };

  const fetchADMachine = () => {
    let pageDetails = {
      tenantId: DOMAIN_ID(),
      filter: "",
      orgId: ORG_ID(),
    };
    // setIsLoading(true);
    axios
      .post(`${REACT_APP_API}/ad/GetAllDomains`, pageDetails, {
        headers: {
          "X-Authorization": AUTH_TOKEN(),
          withCredentials: true,
        },
      })
      .then((res) => {
        // setIsLoading(false);
        const entraID = res?.data?.domains?.filter((domain) => domain.identity_source === "EntraID");
        if (entraID) {
          const entraData = entraID?.map((ad, i) => ({
            id: i + 1,
            value: ad.id,
            label: ad.directoryName,
            ...ad,
          }));
          setEntraDirectory(entraData)
        }

        const ADData = res?.data?.domains?.map((ad, i) => ({
          id: i + 1,
          value: ad.id,
          label: ad.directoryName,
          ...ad,
        }));

        setActiveDirectory(ADData);

        // checks wheather the newly installed ad is present or not
        const adMachine =
          res?.data?.domains?.filter((ad) => ad.id === Number(ADID)) || [];
        const selectedADMachine =
          adMachine.length > 0
            ? {
                id: 1,
                value: adMachine[0].id,
                label: adMachine[0].directoryName,
              }
            : null;

        // fallback if no ad is not present in the list
        const configureAD = [
          {
            id: 1,
            value: "configADWarning",
            label: "Configure Active Directory Agent",
          },
        ];

        if (ADID && adMachine.length > 0) {
          setADData(ADData);
          setFormData([{ name: ["AdMachine"], value: selectedADMachine }]);
          setADInfo("ldap");
          // setAdMfaMode(val.adMfa);
          setAdId(selectedADMachine?.value);
        } else if (ADData.length === 0) {
          setADData(configureAD);
        } else {
          setADData(ADData);
        }
      })
      .catch((err) => {
        // setIsLoading(false);
        if (
          err?.response?.data?.message === "Invalid credentials" ||
          err?.response?.status === 401
        ) {
          logOutUser();
        } else {
          notification.open({
            type: "error",
            content: "Unable to fetch did",
          });
        }
      });
  };

  const fetchGroupsByDomain = async () => {
    let payload = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      pageNo: 1,
      pageSize: 100,
      adId: adId,
    };

    try {
      const res = await axios.post(
        `${REACT_APP_API}/ad/GetAllGroupsByDomain`,
        payload,
        {
          headers: {
            withCredentials: true,
            "X-Authorization": AUTH_TOKEN(),
          },
        }
      );

      const tempGroups = res?.data?.groups?.map((g) => ({
        id: g.id,
        value: g.groupName,
        label: g.groupName,
      }));

      setDomainGroups(tempGroups);
    } catch (error) {
      console.error("fetchGroupsByDomain failed:", error?.response?.status, error?.message);
    }
  };

  const downloadPamCode = async () => {
    try {
      // First fetch tenant details to get the logo URL
      const imageUrl = await fetchTenantDetails();

      // Generate the env file content using our function with the latest image URL
      const textContent = generateEnvContent(imageUrl);

      let fileName = "app.env";
      let fileContent = textContent;
      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(fileContent)
      );
      element.setAttribute("download", fileName);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (error) {
      console.error("Error downloading env file:", error?.response?.status, error?.message);
      notification.open({
        type: "error",
        content: "Error downloading env file",
      });
    }
  };

  const fetchAgentKey = () => {
    let keyData = {
      domainId: DOMAIN_ID(),
      expired: false,
      orgId: ORG_ID(),
    };
    axios
      .post(
        `${REACT_APP_API_PAM_URL}/endpointUsers/generateAgentkey`,
        keyData,
        {
          headers: {
            withCredentials: true,
            "X-Authorization": AUTH_TOKEN(),
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setCode(res.data.agentKey);
        }
      })
      .catch((err) => {
        if (
          err.response.data.message === "Credentials are invalid" ||
          err?.response?.status === 401
        ) {
          notification.open({
            type: "error",
            content: "Credentials are invalid",
          });
          logOutUser();
        } else {
          notification.open({
            type: "error",
            content: "Unable to fetch agent key",
          });
        }
      });
  };

  const handleCopy = (code) => {
    copyText(code).catch(() => {});
  };

  const validateIpAddress = (ip, type) => {
    const validationData = {
      orgId: ORG_ID(),
      tenantId: DOMAIN_ID(),
      [type]: ip,
    };

    return axios.post(
      `${REACT_APP_API_TENANTS_URL}/IsIPExists`,
      validationData,
      {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      }
    );
  };

  const generateDynamicUuid = () => {
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const sections = [8, 4, 4, 4, 12];

    for (let sectionLength of sections) {
      for (let i = 0; i < sectionLength; i++) {
        const randomCharIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomCharIndex);
      }
      result += "-";
    }

    result = result.slice(0, -1);
    setUuid(result);
  };

  const handleIsADPresent = async (ad) => {
    if (ad === "configADWarning") {
      navigate("/pam/directory/addDirectory/step");
    }
  };

  const installCommand =
    userType === "entra"
      ? ".\\windows-agent-install.ps1"
      : ".\\windows-agent-install.ps1 -OutputPath C:\\authnull-agent";

  const finish = () => (onDone ? onDone() : navigate(-1));


  return (
    <OnboardShell
      embedded={embedded}
      eyebrow="PAM · Endpoints · Windows"
      title="Add a Windows endpoint"
      subtitle="Build an installation package for this machine, then run it in an elevated PowerShell session on the target."
      onClose={finish}
      closeLabel="Cancel"
    >
      {setNotification}
      <div style={{ ...card, padding: 18 }}>
        <PartHead
          part="Step 1"
          title="Build the installation package"
          desc="Describe the machine and choose how its users authenticate. The package is generated from these answers, so it only fits this endpoint."
        />
            <Form
              form={form}
              layout="vertical"
              fields={formData}
              onFieldsChange={(_, allFields) => {
                setFormData(allFields);
              }}
              onFinish={() => {
                createZipAndDownload();
              }}
            >
              <Row>
                <Col span={24}>
                  <Row align="middle" gutter={16}>
                    <Col span={24}>
                      <Form.Item
                        name="description"
                        label="Description"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        validateStatus={description.length > 255 ? "error" : ""}
                        help={
                          description.length > 255
                            ? "Description must not exceed 255 characters"
                            : ""
                        }
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="Enter description"
                          value={description}
                          className="border border-gray-500"
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="publicIp"
                        label="Public IP"
                        rules={[
                          {
                            required: true,
                            message: "Public IP is required",
                          },
                          {
                            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
                            message:
                              "IP address range must be 0.0.0.0 to 255.255.255.255",
                          },
                          {
                            validator(rule, value) {
                              return new Promise(async (resolve, reject) => {
                                if (value) {
                                  try {
                                    const resEmail = await validateIpAddress(
                                      value,
                                      "publicIp"
                                    );
                                    const exists = resEmail.data.isExists;
                                    if (exists === "false") {
                                      setPublicIp(value);
                                      resolve();
                                    } else if (exists === "true") {
                                      reject("Public IP already exist");
                                    } else if (exists === "error") {
                                      reject(
                                        "Error in processing your request"
                                      );
                                    }
                                  } catch {
                                    reject();
                                  }
                                } else {
                                  reject();
                                }
                              });
                            },
                          },
                        ]}
                      >
                        <Input className="rounded-md " />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="privateIp"
                        label="Private IP"
                        rules={[
                          {
                            required: true,
                            message: "Private IP is required",
                          },
                          {
                            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
                            message:
                              "IP address range must be 0.0.0.0 to 255.255.255.255",
                          },
                          {
                            validator(rule, value) {
                              return new Promise(async (resolve, reject) => {
                                if (value) {
                                  try {
                                    const resEmail = await validateIpAddress(
                                      value,
                                      "privateIp"
                                    );
                                    const exists = resEmail.data.isExists;
                                    if (exists === "false") {
                                      setPrivateIp(value);
                                      resolve();
                                    } else if (exists === "true") {
                                      reject("Private IP already exist");
                                    } else if (exists === "error") {
                                      reject(
                                        "Error in processing your request"
                                      );
                                    }
                                  } catch {
                                    reject();
                                  }
                                } else {
                                  reject();
                                }
                              });
                            },
                          },
                        ]}
                      >
                        <Input
                          className="rounded-md"
                          // value={privateIp}
                          // onChange={(e) => setPrivateIp(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="fqdn"
                        label="FQDN"
                        rules={[
                          {
                            required: true,
                            message: "FQDN is required",
                          },
                          {
                            pattern:
                              /^(?=.{1,255}$)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
                            message: "Enter a valid FQDN (e.g., example.com)",
                          },
                          {
                            validator(rule, value) {
                              return new Promise(async (resolve, reject) => {
                                if (value) {
                                  try {
                                    const resEmail = await validateIpAddress(
                                      value,
                                      "fqdn"
                                    );
                                    const exists = resEmail.data.isExists;
                                    if (exists === "false") {
                                      setFqdn(value);
                                      resolve();
                                    } else if (exists === "true") {
                                      reject("FQDN is already exist");
                                    } else if (exists === "error") {
                                      reject(
                                        "Error in processing your request"
                                      );
                                    }
                                  } catch {
                                    reject();
                                  }
                                } else {
                                  reject();
                                }
                              });
                            },
                          },
                        ]}
                      >
                        <Input
                          placeholder="example.domain.com"
                          className="rounded-md"
                          // value={fqdn}
                          // onChange={(e) => setFqdn(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        name="token"
                        label={
                          <span>
                            Agent Key{" "}
                            <Tooltip title="Agent Key to be used for registering">
                              <InfoCircleOutlined
                                style={{ color: "rgba(0,0,0,.45)" }}
                              />
                            </Tooltip>
                          </span>
                        }
                        rules={[
                          {
                            required: false,
                            message: "Key is required",
                          },
                        ]}
                      >
                        <Input
                          value={code}
                          className="h-[40px] rounded-md border border-gray-500"
                          disabled
                          suffix={
                            <Text
                              style={{ color: "GrayText" }}
                              copyable={{ text: code }}
                            />
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row align="middle" gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="userType"
                        label="Enforce MFA for"
                        rules={[
                          {
                            required: true,
                            message: "User Type is required",
                          },
                        ]}
                      >
                        <Select
                          options={userTypeOptions}
                          className="h-[40px] rounded-md border border-gray-500"
                          onChange={(value) => {
                            setUserType(value);
                            if (value === "local") {
                              setADInfo(null);
                              setAdId(null);
                            }
                          }}
                          placeholder="Select User Type"
                        />
                      </Form.Item>
                    </Col>
                    {(userType === "ldap" || userType === "both" || userType === "entra") && (
                      <Col span={12}>
                        <Form.Item
                          name="AdMachine"
                          label={
                            <span>
                              Active Directory{" "}
                              <Tooltip title="Select the appropriate Active Directory for user authentication">
                                <InfoCircleOutlined
                                  style={{ color: "rgba(0,0,0,.45)" }}
                                />
                              </Tooltip>
                            </span>
                          }
                        >
                          <Select
                            onChange={(e, val) => {
                              setADInfo(val);
                              setAdMfaMode(val.adMfa);
                              setAdId(val.id);
                              handleIsADPresent(val.value);
                            }}
                            options={aDData}
                            className="h-[40px] rounded-md border border-gray-500"
                            placeholder="Select Active Directory"
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                  <Row align="middle" gutter={16}>
                    {adMfaMode === 1 &&
                      aDInfo !== null &&
                      (userType === "ldap" || userType === "both") && (
                        <Col span={12}>
                          <Form.Item
                            name="adGroups"
                            label={
                              <span>
                                Select Groups{" "}
                                <Tooltip title="Select the groups that are needed to be added in this is machine for remote access.">
                                  <InfoCircleOutlined
                                    style={{ color: "rgba(0,0,0,.45)" }}
                                  />
                                </Tooltip>
                              </span>
                            }
                          >
                            <Select
                              mode="multiple"
                              placeholder="Select groups"
                              className="h-[40px] rounded-md border border-gray-500"
                              options={domainGroups}
                              onChange={(val) => {
                                setSelectedGroups(val);
                              }}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    {(userType === "local" ||
                      ((userType === "ldap" || userType === "both" || userType === "entra") &&
                        aDInfo &&
                        selectedGroups !== "configADWarning")) && (
                      <Col span={12}>
                        <Button type="primary" htmlType="submit">
                          Download <DownloadOutlined />
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </Form>
      </div>

      <div style={{ ...card, padding: 18 }}>
        <PartHead part="Steps 2-4" title="Install on the target machine" desc="Everything below runs on the Windows host, not here." />

        <StepRow n={2} title="Copy the package across" desc="Extract the downloaded zip and copy the extracted folder to the target machine." />

        <StepRow n={3} title="Open PowerShell as Administrator" desc="Then allow the script to run in this session.">
          <CodeBlock copyText="Set-ExecutionPolicy Unrestricted -Scope CurrentUser">
            Set-ExecutionPolicy Unrestricted -Scope CurrentUser
          </CodeBlock>
        </StepRow>

        <StepRow n={4} title="Run the installer" desc="This onboards the Windows machine to Authnull." last>
          <CodeBlock copyText={installCommand} multiline>{installCommand}</CodeBlock>
        </StepRow>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <Button onClick={finish}>Cancel</Button>
        <Button type="primary" htmlType="submit" onClick={finish}>Finish</Button>
      </div>
    </OnboardShell>
  );
};
